// extracted by mini-css-extract-plugin
module.exports = {"OSDToolbar":"ead","icon":"eae","withSpacer":"eaf","roundedUp":"eah"};